import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import { categories, categoriesBind, myCategories } from '@/api/mg';
export default {
  data: function data() {
    return {
      // arr: [{ selected: false, value: 'Hot', src: require('../../assets/images/Hot.png') }, { selected: false, value: 'Club', src: require('../../assets/images/Clue.png') }, { selected: true, value: 'Activity', src: require('../../assets/images/Activity.png') }, { selected: false, value: 'Video', src: require('../../assets/images/Video.png') }, { selected: true, value: 'News', src: require('../../assets/images/News.png') }, { selected: false, value: 'Q&A', src: require('../../assets/images/Q&A.png') }, { selected: false, value: 'Knowledge', src: require('../../assets/images/Knowledge.png') }],
      arr: [],
      isShow: true,
      params: {}
    };
  },
  created: function created() {
    // this.getCategories({ is_menu: 1 })
    this.getData();
  },
  methods: {
    getData: function getData() {
      var _this = this;
      Promise.all([categories({
        is_menu: 1
      }), myCategories()]).then(function (res) {
        console.log(res, 'res');
        _this.arr = res[0].Data;
        _this.arr.forEach(function (item, index) {
          item.selected = false;
        });
        _this.isShow = false;
        _this.arr.forEach(function (item, index) {
          res[1].Data.category.forEach(function (itm, idx) {
            if (item.name === itm) {
              item.selected = true;
            }
          });
        });
        _this.isShow = true;
      });
    },
    getMyCategories: function getMyCategories(params) {
      var _this2 = this;
      myCategories(params).then(function (res) {
        if (res.Code === 0) {
          console.log(res.Data.category, 'res.Data');
          _this2.isShow = false;
          _this2.arr.forEach(function (item, index) {
            res.Data.category.forEach(function (itm, idx) {
              if (item.name === itm) {
                item.selected = true;
              }
            });
          });
          _this2.isShow = true;
          console.log(_this2.arr, 'this.arr');
        } else {
          _this2.$toast(res.Message);
        }
      });
    },
    bind: function bind(params) {
      var _this3 = this;
      categoriesBind(params).then(function (res) {
        if (res.Code === 0) {
          _this3.$router.back();
        } else {
          _this3.$toast(res.Message);
        }
      });
    },
    getCategories: function getCategories(params) {
      var _this4 = this;
      categories(params).then(function (res) {
        if (res.Code === 0) {
          _this4.arr = res.Data;
          _this4.arr.forEach(function (item, index) {
            item.selected = false;
          });
          _this4.getMyCategories();
        } else {
          _this4.$toast(res.Message);
        }
      });
    },
    toSave: function toSave() {
      var fllterArr = this.arr.filter(function (item, index) {
        return item.selected === true;
      });
      var ids = [];
      fllterArr.forEach(function (item, index) {
        ids.push(item.pid);
      });
      this.params.ids = ids;
      console.log(this.params, 'params');
      this.bind(this.params);
      // this.$toast('拉保存接口然后返回')
      // const timer = setTimeout(() => {
      //   this.$router.back()
      //   clearTimeout(timer)
      // }, 1000)
    },
    toSelect: function toSelect(itm) {
      this.isShow = false;
      itm.selected = !itm.selected;
      this.isShow = true;
      // const arr = this.arr.filter((item) => {
      //   return item.selected === true
      // })
      console.log(this.arr);
    }
  }
};